var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-parallax-view",style:({ width: _vm.width, height: _vm.height })},_vm._l((_vm.stageLayers),function(layer,index){return _c('div',{key:index,ref:`layer_${layer.name}`,refInFor:true,staticClass:"vue-parallax-view-layer",class:layer.class,style:({
      backgroundImage: 'url(' + layer.img + ')',
      left: layer.horizontalOffset,
      right: layer.horizontalOffset,
      top: layer.verticalOffset,
      bottom: layer.verticalOffset
    }),attrs:{"id":`vue_parallax_layer_${layer.name}`}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }